/* unplugin-vue-components disabled */import script from "./viptabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./viptabs.vue?vue&type=script&lang=ts&setup=true"

import "./viptabs.vue?vue&type=style&index=0&id=08366a71&lang=css"

const __exports__ = script;

export default __exports__